import React, { useState, useEffect } from 'react';
import PokketLottie from './PokketLottie';

const LOTTIE_URL = 'https://db.pokketcoach.com/storage/v1/object/public/public-animations/lottie-animations/pokketsleeping.json';

const PokketThinking = ({ className }) => {
  const [animationData, setAnimationData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAnimationData = async () => {
      try {
        const response = await fetch(LOTTIE_URL);
        if (!response.ok) {
          throw new Error(`Failed to fetch animation: ${response.status}`);
        }
        const data = await response.json();
        setAnimationData(data);
        setIsLoading(false);
      } catch (err) {
        console.error('Error loading Lottie animation:', err);
        setError(err.message);
        setIsLoading(false);
      }
    };

    fetchAnimationData();
  }, []);

  if (isLoading) {
    return <div className="loading-placeholder h-24 w-24 animate-pulse bg-blue-100 rounded-full mx-auto"></div>;
  }

  if (error) {
    console.error('Failed to load animation:', error);
    return null; // Return null if animation fails to load to avoid UI disruption
  }

  return (
    <div className="lottie-container" style={{ width: '100%', maxWidth: '400px', maxHeight: '400px', margin: '0 auto' }}>
      <PokketLottie 
        animationPath={animationData} 
        width="100%" 
        height="100%"
        className={className}
      />
    </div>
  );
};

export default PokketThinking; 